var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62145 2.89265C8.37607 2.36912 7.62393 2.36912 7.37856 2.89265L6.01777 5.79612C5.91804 6.00892 5.7142 6.15557 5.47886 6.18383L2.26998 6.5692C1.69163 6.63865 1.45934 7.34542 1.88577 7.73822L4.2545 9.92011C4.42778 10.0797 4.50549 10.3165 4.46001 10.5464L3.83815 13.6903C3.72616 14.2564 4.33452 14.6933 4.8438 14.4126L7.66661 12.8564C7.87388 12.7422 8.12613 12.7422 8.3334 12.8564L11.1562 14.4126C11.6655 14.6933 12.2738 14.2564 12.1619 13.6903L11.54 10.5464C11.4945 10.3165 11.5722 10.0797 11.7455 9.92011L14.1142 7.73822C14.5407 7.34542 14.3084 6.63865 13.73 6.5692L10.5211 6.18383C10.2858 6.15557 10.082 6.00892 9.98224 5.79612L8.62145 2.89265Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.0c90f2c9406c80cd63bd51709607d954.svg";
export { ForwardRef as ReactComponent };